
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as CheckIconComponent } from "./check-icon.svg";

export const CheckIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <CheckIconComponent {...props} />;
};
